import { Icon } from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { mdiChevronDown, mdiChevronUp, mdiSwapHorizontal } from "@mdi/js";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { HybridRouteListItemButtonLink } from "../HybridRouteListItemButtonLink";
import type { MenuWithSubmenu } from "./Menu";

export const NegotiationsMenu: React.FC<MenuWithSubmenu> = memo(
  ({ handleClick, leftMenuOpen, openSubmenu, user }) => {
    const { t } = useTranslation();

    if (!user.vendor) {
      return null;
    }

    if (
      !(
        user.roles_names.includes("View Vbuyer") &&
        user.roles_names.includes("View Negotiations")
      )
    ) {
      return null;
    }

    return (
      <>
        <ListItemButton
          // name="negotiations"
          onClick={() => handleClick("negotiations")}
          title={t("menu.negotiations.title")}
        >
          <ListItemIcon sx={{ minWidth: "2rem" }}>
            <Icon icon={mdiSwapHorizontal} />
          </ListItemIcon>
          {!!leftMenuOpen && (
            <ListItemText
              primary={t("menu.negotiations.title")}
              slotProps={{
                primary: {
                  sx: {
                    fontSize: 14,
                  },
                },
              }}
              sx={{ whiteSpace: "normal" }}
            />
          )}
          <Icon
            icon={openSubmenu.negotiations ? mdiChevronUp : mdiChevronDown}
          />
        </ListItemButton>
        <Collapse in={openSubmenu.negotiations} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <HybridRouteListItemButtonLink
              caption="negotiations open"
              isReact={false}
              name="negotiations[open]"
              sx={{ pl: 4 }}
              title={t("menu.negotiations.submenu.open.title")}
              url="/vbuyer/negotiations/open"
            >
              <ListItemText
                primary={t("menu.negotiations.submenu.open.title")}
                slotProps={{
                  primary: { sx: { fontSize: 14 } },
                }}
                sx={{ whiteSpace: "normal" }}
              />
            </HybridRouteListItemButtonLink>

            <HybridRouteListItemButtonLink
              caption="negotiations ongoing"
              isReact={false}
              name="negotiations[ongoing]"
              sx={{ pl: 4 }}
              title={t("menu.negotiations.submenu.ongoing.title")}
              url="/vbuyer/negotiations/ongoing"
            >
              <ListItemText
                primary={t("menu.negotiations.submenu.ongoing.title")}
                slotProps={{
                  primary: { sx: { fontSize: 14 } },
                }}
                sx={{ whiteSpace: "normal" }}
              />
            </HybridRouteListItemButtonLink>

            <HybridRouteListItemButtonLink
              caption="negotiations completed"
              isReact={false}
              name="negotiations[completed]"
              sx={{ pl: 4 }}
              title={t("menu.negotiations.submenu.completed.title")}
              url="/vbuyer/negotiations/completed"
            >
              <ListItemText
                primary={t("menu.negotiations.submenu.completed.title")}
                slotProps={{
                  primary: { sx: { fontSize: 14 } },
                }}
                sx={{ whiteSpace: "normal" }}
              />
            </HybridRouteListItemButtonLink>

            <HybridRouteListItemButtonLink
              caption="quality checklists"
              isReact={false}
              name="negotiations[qualityChecklists]"
              sx={{ pl: 4 }}
              title={t("menu.negotiations.submenu.qualityChecklists.title")}
              url="/vbuyer/guides"
            >
              <ListItemText
                primary={t("menu.negotiations.submenu.qualityChecklists.title")}
                slotProps={{
                  primary: { sx: { fontSize: 14 } },
                }}
                sx={{ whiteSpace: "normal" }}
              />
            </HybridRouteListItemButtonLink>
          </List>
        </Collapse>
      </>
    );
  },
);
